import {useState} from "react";
import CustomDialog from "../../../core/components/ui/CustomDialog";
import {Box, CircularProgress} from "@mui/material";
import CustomDialogLoaderComponent from "../../../core/components/common/custom-dialog-loader.component"
import GatePassStatusDropdownComponent from "../common/gate-pass-status-dropdown.component";
import useGatePass from "../hooks/useGatePass";
import CustomTypography from "../../../core/components/ui/CustomTypography";
import CustomTextField from "../../../core/components/ui/CustomTextfield";
import {useLocation} from "react-router-dom";


const UpdateStatusDialog = (props) => {
    const {open, setOpen, selectedGatePass} = props;

    const location = useLocation();
    
    const {isUpdatingGatePassStatus, updateGatePassStatus, updateOrgGatePassStatus} = useGatePass();

    const [selectedStatus, setSelectedStatus] = useState(selectedGatePass?.status);
    const [reasonInput, setReasonInput] = useState(selectedGatePass?.purpose || "");


    const handleTextfieldChange = (e) => {
        setReasonInput(e.target.value);
    }

    const handleStatusChange = (value) => {
        setSelectedStatus(value);
    }

    const handleClose = () => {
        setOpen(false);
    }

    const handleUpdateStatus = () => {
        const reasonForStatus = (selectedStatus !== "Active" && selectedStatus !== "For Approval") ? reasonInput : " ";
       
            const parameters = {
                gatepassUID: selectedGatePass?.gatepass_uid,       
                status: selectedStatus,
                purpose: reasonForStatus,
                orgUID: selectedGatePass?.org_uid
            }

            updateGatePassStatus(parameters, setOpen);
    }

    const actions = [
        {
            label: "Cancel",
            onClick: (e) => setOpen(false),
            variant: "outlined",
            customStyles: {
                opacity: 1, mr: 1
            }
        },
        {
            label: "Update",
            onClick: (e) => (!selectedStatus || isUpdatingGatePassStatus || ((selectedStatus !== "Active" && selectedStatus !== "For Approval") && !reasonInput.trim())) ? null : handleUpdateStatus(e),
            customStyles: {
                opacity: (!selectedStatus || isUpdatingGatePassStatus || ((selectedStatus !== "Active" && selectedStatus !== "For Approval") && !reasonInput.trim())) ? "55%" : "100%",
                cursor: (!selectedStatus || isUpdatingGatePassStatus || ((selectedStatus !== "Active" && selectedStatus !== "For Approval") && !reasonInput.trim())) ? "not-allowed !important" : "pointer",
                visibility: (isUpdatingGatePassStatus) ? "hidden" : "visible",
            },
        }
    ]

    const globalSx = {
       //
    }


    return (
        <>
            <CustomDialog
                open={open}
                onClose={(isUpdatingGatePassStatus) ? null : handleClose}
                title="Update Status"
                subtitle={"Manage gate pass status in real-time"}
                hasDividers={true}
                content={
                    <Box>
                        {(isUpdatingGatePassStatus) ? 
                            <Box sx={{mb: "80px"}}>
                                <CustomDialogLoaderComponent 
                                    icon={<CircularProgress size={40} sx={{color: "#2196f3"}} />} 
                                    message={"Updating gate pass status..."}
                                />
                            </Box>
                        : 
                            <>
                                <CustomTypography 
                                    variant="subtitle2"
                                    text={"Status"}
                                    customStyles={{
                                        mb: (selectedStatus) ? 1 : 1
                                    }}
                                />

                                <GatePassStatusDropdownComponent 
                                    value={selectedStatus}
                                    onChange={handleStatusChange}
                                    fullWidth={true}
                                    size={"medium"}
                                /> <br/>

                                {(selectedStatus !== "Active" && selectedStatus !== "For Approval") && 
                                    <>
                                        <CustomTypography 
                                            variant="subtitle2"
                                            text={"Reason"}
                                            customStyles={{}}
                                        />
                                        <CustomTextField 
                                            placeholder={"Enter reason"}
                                            variant={"outlined"}
                                            value={reasonInput}
                                            onChange={(e) => handleTextfieldChange(e)}
                                            fullWidth={true}
                                            multiline={false}
                                            hiddenLabel
                                            readOnly={isUpdatingGatePassStatus}
                                            helperText={(!reasonInput.trim()) ? "Reason is required" : false}
                                            
                                        /> 
                                    </>   
                                }
                            </>
                        }
                    </Box>
                }
                actions={!isUpdatingGatePassStatus && actions}
                maxWidth={"sm"}
                customStyles={{}}
                globalSx={globalSx}
            />
        </>
    )
}

export default UpdateStatusDialog
